module.exports = __webpack_public_path__ + "img/headline_bg.af3c5f7c.png";